import { render, staticRenderFns } from "./bid.vue?vue&type=template&id=0d8db8de"
import script from "./bid.vue?vue&type=script&lang=js"
export * from "./bid.vue?vue&type=script&lang=js"
import style0 from "./bid.vue?vue&type=style&index=0&id=0d8db8de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports